// extracted by mini-css-extract-plugin
export default {"icon":"ClientsImportCollision--icon--a2ac28","container":"ClientsImportCollision--container--0d9b3d"};